import React from 'react'

const AdminBus = () => {
  return (
    <div>AdminBus</div>
  )
}

export default AdminBus